export const COUPLE_NAME = process.env.REACT_APP_COUPLE_NAME ?? "Taline & Atish";
export const WEDDING_DATE = process.env.REACT_APP_WEDDING_DATE ?? "2026-07-29T00:00:00+04:00";
export const WEDDING_DATE_DISPLAY = process.env.REACT_APP_WEDDING_DATE_DISPLAY ?? "July 29, 2026";
export const WEDDING_LOCATION = process.env.REACT_APP_WEDDING_LOCATION ?? "Mauritius";

export const RSVP_FORM_URL =
  process.env.REACT_APP_RSVP_FORM_URL ??
  "https://script.google.com/macros/s/AKfycbyErGM-FLgMNtodN4SWG2W2akDmKCbb09rXxCQt0NjZuDuD2Yrr3EgoJvJRCuNil0zj/exec";

export const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL ?? "taline.atish@gmail.com";

export const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID ?? "";
export const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID ?? "";
export const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY ?? "";

export const SITE_PW_PLAIN = process.env.REACT_APP_SITE_PW;
export const SITE_PW_HASH = process.env.REACT_APP_SITE_PW_HASH;
export const SITE_STORAGE_KEY = process.env.REACT_APP_SITE_STORAGE_KEY;

export const GOOGLE_MAPS_URL =
  process.env.REACT_APP_GOOGLE_MAPS_URL ??
  "https://goo.gl/maps/SLC3E7fYnWAG7L9g8";

export const GOOGLE_MAPS_EMBED_SRC =
  process.env.REACT_APP_GOOGLE_MAPS_EMBED_SRC ??
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d239756.607300514!2d57.4472580182625!3d-20.12582776774339!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x217dabb211fca365%3A0x1bad336a95495835!2sIsland%20View%20Garden!5e0!3m2!1sfr!2sfr!4v1773456791119!5m2!1sfr!2sfr";
